module.exports = __webpack_public_path__ + "static/media/PayPal.4f7311a4.svg";